<script lang="ts">
  // Narrowing the activity dashboard to particular tags -- standard or the athlete's own custom
  // ones (see CustomActivityTags.svelte, which applies them). Tags are picked from the same kind of
  // dropdown as the "+" on an activity and listed as removable pills; an activity matches if it has
  // any one of them.
  import * as Popover from '$lib/components/ui/popover';
  import { Button } from '@/lib/components/ui/button';
  import { cn } from '@/lib/utils';
  import { tagVariants } from '@/Common/ActivityTag';
  import ActivityTagPill from '@/Common/ActivityTagPill.svelte';
  import ActivityTagMenuList from '@/Common/ActivityTagMenuList.svelte';
  import type { ActivityFilterFields } from './ActivityFilterFields';
  import { activityTagOptions, allTags, tagColors } from '@/Common/activityTagOptions';

  export let fields: ActivityFilterFields;

  const options = activityTagOptions();
  $: offered = allTags($options);
  $: colors = tagColors($options);

  let open = false;

  $: selected = fields.customTags;

  function toggle(tag: string) {
    fields.toggleCustomTag(tag);
    fields = fields;
  }
</script>

<div>
  <div class="flex flex-row items-center justify-between gap-2">
    <h3 class="text-sm font-medium tracking-wide text-muted-foreground m-0">Tags</h3>
    {#if selected.length}
      <Button variant="ghost" size="sm" class="text-xs h-7 px-2" on:click={() => { fields.clearCustomTags(); fields = fields; }}>
        Clear
      </Button>
    {/if}
  </div>

  <div class="flex flex-row flex-wrap items-center gap-1 mt-1">
    {#each selected as tag (tag)}
      <ActivityTagPill {tag} color={colors.get(tag)} size="medium" onRemove={() => toggle(tag)} />
    {/each}

    <Popover.Root portal="#shadcn-ui-dialog-target" bind:open>
      <Popover.Trigger asChild let:builder>
        <button
          use:builder.action
          {...builder}
          type="button"
          class={cn(tagVariants({ variant: 'button', size: 'medium' }), 'gap-1')}
          title="Filter by tag"
        >
          <i class="fa-solid fa-plus text-[10px]" aria-hidden="true"></i>
          {#if !selected.length}<span>Add tag</span>{/if}
        </button>
      </Popover.Trigger>
      <Popover.Content class="w-56 min-w-0 p-2">
        <ActivityTagMenuList tags={offered} {selected} onToggle={toggle} />
      </Popover.Content>
    </Popover.Root>
  </div>
</div>
